import React from "react";
import { useTranslation } from "react-i18next";
import { useTelemetry } from "../../context/TelemetryContext";
import { useIndustry } from "../../context/IndustryContext";
import ModeIndicator from "../../components/shared/ModeIndicator";
import LanguageToggle from "../../components/shared/LanguageToggle";
import DemoDataNotice from "../../components/shared/DemoDataNotice";
import SubPageNav from "../../components/shared/SubPageNav";

const INDUSTRY_KEY = {
  "School": "school",
  "Airport": "airport",
  "Public Event": "publicEvent",
  "Border Security": "borderSecurity",
  "Military": "military",
};

function Dashboard() {
const { t } = useTranslation();

const telemetry = useTelemetry();
const { industry } = useIndustry();

const industryKey = INDUSTRY_KEY[industry] || "school";
const autonomyLevel = t(`governance.industry.autonomyLevels.${industryKey}`);

const riskKey =
  telemetry.overallRisk === "CRITICAL"
    ? "critical"
    : telemetry.overallRisk === "WARNING"
    ? "warning"
    : "safe";

const alerts = t(`dashboard.alertCenter.alerts.${riskKey}`, { returnObjects: true });

return (

<div
style={{
padding: "8px",
color: "white"
}}
>


{/* ===================================================== */}
{/* ===== TOP COMMAND CENTER CARDS ===== */}
{/* ===================================================== */}

<div
  style={{
    textAlign: "center",
    marginBottom: "30px"
  }}
>
  <div style={{position:"relative",textAlign:"center",marginBottom:"20px"}}><h1
    style={{
      fontSize: "58px",
      marginBottom: "8px"
    }}
  >
    {t("dashboard.title")}
  </h1><div style={{position:"absolute",top:0,right:0,display:"flex",alignItems:"flex-start",gap:"12px"}}><LanguageToggle /><ModeIndicator /></div></div>

  <p
    style={{
      color: "#94a3b8",
      fontSize: "14px",
      margin: 0
    }}
  >
    {t("dashboard.lastUpdated", { value: new Date().toLocaleTimeString() })}
  </p>
</div>

<div
style={{
display: "grid",
gridTemplateColumns: "repeat(3, 1fr)",
gap: "20px"
}}
>

{/* Industry */}

<div
style={{
background: "#111827",
padding: "8px",
minHeight: "180px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("dashboard.activeDeployment.title")}</h3>

<h2
style={{
marginTop: "15px",
color: "#38bdf8"
}}
>
{industry}
</h2>

<p
style={{
marginTop: "10px",
color: "#94a3b8"
}}
>
{t("dashboard.activeDeployment.subtitle")}
</p>

</div>

{/* Risk */}

<div
style={{
background: "#111827",
padding: "8px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("dashboard.facilityRiskStatus.title")}</h3>

<h1
style={{
marginTop: "15px",
color:
telemetry.overallRisk === "CRITICAL"
? "#ef4444"
: telemetry.overallRisk === "WARNING"
? "#f59e0b"
: "#22c55e"
}}
>
{t(`commandCenter.risk.${telemetry.overallRisk}`, telemetry.overallRisk)}
</h1>

<p
style={{
marginTop: "10px",
color: "#94a3b8"
}}
>
{t("dashboard.facilityRiskStatus.subtitle")}
</p>

</div>

{/* Autonomy */}

<div
style={{
background: "#111827",
padding: "8px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3>{t("dashboard.autonomyMode.title")}</h3>

<h2
style={{
marginTop: "15px",
color: "#38bdf8"
}}
>
{autonomyLevel}
</h2>

<p
style={{
marginTop: "10px",
color: "#94a3b8"
}}
>
{t("dashboard.autonomyMode.subtitle")}
</p>

</div>
</div>




{/* ===================================================== */}
{/* ===== MISSION STATUS ===== */}
{/* ===================================================== */}

<div
style={{
marginTop: "15px",
padding: "15px",
borderRadius: "12px",
textAlign: "center",
background:
telemetry.overallRisk === "CRITICAL"
? "rgba(239,68,68,0.12)"
: telemetry.overallRisk === "WARNING"
? "rgba(245,158,11,0.12)"
: "rgba(34,197,94,0.12)",
border:
telemetry.overallRisk === "CRITICAL"
? "1px solid #ef4444"
: telemetry.overallRisk === "WARNING"
? "1px solid #f59e0b"
: "1px solid #22c55e"
}}
>
<h3
style={{
margin: 0,
color:
telemetry.overallRisk === "CRITICAL"
? "#ef4444"
: telemetry.overallRisk === "WARNING"
? "#f59e0b"
: "#22c55e"
}}
>
{t(`dashboard.missionStatusBanner.${riskKey}`)}
</h3>
</div>

<div
style={{
marginTop: "20px",
background: "#111827",
padding: "15px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>
<h2
style={{
marginBottom: "25px"
}}
>
{t("dashboard.riskAssessment.title")}
</h2>

<div
style={{
display: "grid",
gridTemplateColumns: "45% 55%",
alignItems: "center",
gap: "15px"
}}
>
{/* LEFT PANEL */}

<div>

<h3
style={{
marginBottom: "15px",
color: "#38bdf8"
}}
>
{t("dashboard.riskAssessment.riskEngineIntelligence")}
</h3>

<p style={{ margin: "8px 0" }}>
{t("dashboard.riskAssessment.riskClassification")}
<strong> {t(`commandCenter.risk.${telemetry.overallRisk}`, telemetry.overallRisk)}</strong>
</p>

<p style={{ margin: "8px 0" }}>
{t("dashboard.riskAssessment.aiConfidence")}
<strong> {telemetry.aiConfidence}%</strong>
</p>

<p style={{ margin: "8px 0" }}>
{t("dashboard.riskAssessment.pm25")}
<strong> {telemetry.pm25}</strong>
</p>

<p style={{ margin: "8px 0" }}>
{t("dashboard.riskAssessment.voc")}
<strong> {telemetry.voc}</strong>
</p>

<p style={{ margin: "8px 0" }}>
{t("dashboard.riskAssessment.exposureSignal")}
<strong> {telemetry.fentanyl_ppb}</strong>
</p>

<p
style={{
marginTop: "20px",
color: "#22c55e"
}}
>
{t("dashboard.riskAssessment.analysisComplete")}
</p>
</div>

{/* RIGHT PANEL */}

<div
style={{
display: "flex",
flexDirection: "column",
alignItems: "center",
justifyContent: "center"
}}
>

<div
style={{
width: "190px",
height: "190px",
borderRadius: "50%",
display: "flex",
flexDirection: "column",
justifyContent: "center",
alignItems: "center",
border:
telemetry.overallRisk === "CRITICAL"
? "12px solid #ef4444"
: telemetry.overallRisk === "WARNING"
? "12px solid #f59e0b"
: "12px solid #22c55e",
boxShadow:
telemetry.overallRisk === "CRITICAL"
? "0 0 35px rgba(239,68,68,.5)"
: telemetry.overallRisk === "WARNING"
? "0 0 35px rgba(245,158,11,.5)"
: "0 0 35px rgba(34,197,94,.5)"
}}
>

<h1
style={{
fontSize: "85px",
margin: 0,
color:
telemetry.overallRisk === "CRITICAL"
? "#ef4444"
: telemetry.overallRisk === "WARNING"
? "#f59e0b"
: "#22c55e"
}}
>
{telemetry.aiConfidence}
</h1>

<p
style={{
marginTop: "10px",
fontWeight: "bold",
fontSize: "22px"
}}
>
{t(`commandCenter.risk.${telemetry.overallRisk}`, telemetry.overallRisk)}
</p>

</div>

<p
style={{
marginTop: "20px",
color: "#94a3b8",
fontSize: "15px",
textAlign: "center"
}}

>
{t("dashboard.riskAssessment.confidenceScoreLabel")}
</p>
{telemetry.dataSource !== "LIVE" && <DemoDataNotice textKey="common.demoDataNotice.simulatedConfidence" />}
</div>
</div>
</div>

{/* ===================================================== */}
{/* ===== RISKENGINE INSIGHTS ===== */}
{/* ===================================================== */}

<div
style={{
marginTop: "10px",
background: "#111827",
padding: "6px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h4
style={{
marginBottom: "10px",
textAlign: "center"
}}
>
{t("dashboard.decisionInsights.title")}
</h4>

<div
style={{
display: "grid",
gridTemplateColumns: "repeat(4, 1fr)",
gap: "15px"
}}
>

<div
style={{
background: "#0f172a",
padding: "10px",
borderRadius: "10px",
textAlign: "center"
}}
>
<p style={{ color: "#38bdf8" }}>
{t("dashboard.decisionInsights.pm25Impact")}
</p>

<h2>
{telemetry.pm25 > 60 ? "+20" : "+5"}
</h2>
</div>

<div
style={{
background: "#0f172a",
padding: "10px",
borderRadius: "10px",
textAlign: "center"
}}
>
<p style={{ color: "#22c55e" }}>
{t("dashboard.decisionInsights.vocImpact")}
</p>

<h3 style={{ margin: "5px 0" }}>
{telemetry.voc > 300 ? "+25" : "+10"}
</h3>
</div>

<div
style={{
background: "#0f172a",
padding: "10px",
borderRadius: "10px",
textAlign: "center"
}}
>
<p style={{ color: "#f59e0b" }}>
{t("dashboard.decisionInsights.exposureImpact")}
</p>

<h2>
{telemetry.fentanyl_ppb > 6 ? "+40" : "+0"}
</h2>
</div>

<div
style={{
background: "#0f172a",
padding: "15px",
borderRadius: "10px",
textAlign: "center"
}}
>
<p style={{ color: "#ef4444" }}>
{t("dashboard.decisionInsights.finalRiskScore")}
</p>

<h2>
{telemetry.aiConfidence}
</h2>
</div>

</div>

</div>


{/* ===================================================== */}
{/* =====Live Telemetry Metrics ===== */}
{/* ===================================================== */}

<h4
style={{
marginBottom: "20px",
textAlign: "center"
}}
>
{t("dashboard.environmentalTelemetry.title")}
</h4>

<div
style={{
display: "grid",
gridTemplateColumns: "repeat(4, 1fr)",
gap: "10px",
marginTop: "20px"
}}
>

<div
style={{
background: "#0f172a",
padding: "8px",
borderRadius: "12px",
textAlign: "center",
border: "1px solid #1e293b"
}}
>
<h1
style={{
color: "#38bdf8",
margin: "0",
fontSize: "42px"
}}
>
{telemetry.pm25}
</h1>

<p style={{ color: "#94a3b8" }}>
{t("dashboard.environmentalTelemetry.pm25")}
</p>
</div>

<div
style={{
background: "#0f172a",
padding: "8px",
borderRadius: "12px",
textAlign: "center",
border: "1px solid #1e293b"
}}
>
<h1
style={{
color: "#38bdf8",
margin: "0",
fontSize: "42px"
}}
>
{telemetry.voc}
</h1>

<p style={{ color: "#94a3b8" }}>
{t("dashboard.environmentalTelemetry.voc")}
</p>
</div>
<div
style={{
background: "#0f172a",
padding: "8px",
borderRadius: "12px",
textAlign: "center",
border: "1px solid #1e293b"
}}
>
<h1
style={{
color: "#f59e0b",
margin: "0",
fontSize: "42px"
}}
>
{telemetry.fentanyl_ppb}
</h1>

<p style={{ color: "#94a3b8" }}>
{t("dashboard.environmentalTelemetry.exposureSignal")}
</p>
</div>

<div
style={{
background: "#0f172a",
padding: "8px",
borderRadius: "12px",
textAlign: "center",
border: "1px solid #1e293b"
}}
>
<h2 style={{ color: "#ef4444" }}>
{telemetry.aiConfidence}%
</h2>

<p style={{ color: "#94a3b8" }}>
{t("dashboard.environmentalTelemetry.aiConfidence")}
</p>
</div>
</div>

{/* ===== AI ALERT CENTER ===== */}

<div
style={{
marginTop: "15px",
background: "#111827",
padding: "12px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3
style={{
marginBottom: "20px",
textAlign: "center"
}}
>
{t("dashboard.alertCenter.title")}
</h3>


<div
style={{
display: "flex",
justifyContent: "center",
gap: "10px",
flexWrap: "wrap"
}}
>


{alerts.map((alert, index) => (

<div
key={index}
style={{
padding: "8px 12px",
background: "#0f172a",
borderRadius: "10px",
borderLeft:
telemetry.overallRisk === "CRITICAL"
? "4px solid #ef4444"
: telemetry.overallRisk === "WARNING"
? "4px solid #f59e0b"
: "4px solid #22c55e"
}}
>
{alert}
</div>

))}

</div>

</div>




{/* ===================================================== */}
{/* ===== AI SYSTEM STATUS ===== */}
{/* ===================================================== */}



<div
style={{
marginTop: "15px",
background: "#111827",
padding: "20px",
borderRadius: "14px",
border: "1px solid #1e293b"
}}
>

<h3
style={{
marginBottom: "20px",
textAlign: "center"
}}
>
{t("dashboard.agentNetwork.title")}
</h3>

<p
style={{
textAlign: "center",
color: "#94a3b8",
marginTop: "-10px",
marginBottom: "15px",
fontSize: "14px"
}}
>
{t("dashboard.agentNetwork.subtitle")}
</p>

<div
style={{
display: "grid",
gridTemplateColumns: "repeat(7, 1fr)",
gap: "12px"
}}
>

{/* DecisionAgent */}

<div
style={{
padding: "12px",
minHeight: "60px",
textAlign: "center",
background: "#0f172a",
borderRadius: "10px",
border: "1px solid #1e293b"
}}
>
<h4 style={{ marginBottom: "8px" }}>
{t("dashboard.agentNetwork.decisionAgent")}
</h4>

<p style={{ color: "#22c55e", margin: 0 }}>
🟢 {t("commandCenter.status.active")}
</p>
</div>

{/* ExplainabilityAgent */}

<div
style={{
padding: "12px",
minHeight: "60px",
textAlign: "center",
background: "#0f172a",
borderRadius: "10px",
border: "1px solid #1e293b"
}}
>
<h4 style={{ marginBottom: "8px" }}>
{t("dashboard.agentNetwork.explainabilityAgent")}
</h4>

<p style={{ color: "#22c55e", margin: 0 }}>
🟢 {t("commandCenter.status.active")}
</p>
</div>

{/* ForecastAgent */}

<div
style={{
padding: "12px",
minHeight: "60px",
textAlign: "center",
background: "#0f172a",
borderRadius: "10px",
border: "1px solid #1e293b"
}}
>
<h4 style={{ marginBottom: "8px" }}>
{t("dashboard.agentNetwork.forecastAgent")}
</h4>

<p style={{ color: "#22c55e", margin: 0 }}>
🟢 {t("commandCenter.status.active")}
</p>
</div>

{/* GovernanceAgent */}

<div
style={{
padding: "12px",
minHeight: "60px",
textAlign: "center",
background: "#0f172a",
borderRadius: "10px",
border: "1px solid #1e293b"
}}
>
<h4 style={{ marginBottom: "8px" }}>
{t("dashboard.agentNetwork.governanceAgent")}
</h4>

<p style={{ color: "#22c55e", margin: 0 }}>
🟢 {t("commandCenter.status.active")}
</p>
</div>

{/* RecommendationAgent */}

<div
style={{
padding: "12px",
minHeight: "60px",
textAlign: "center",
background: "#0f172a",
borderRadius: "10px",
border: "1px solid #1e293b"
}}
>
<h4 style={{ marginBottom: "8px" }}>
{t("dashboard.agentNetwork.recommendationAgent")}
</h4>

<p style={{ color: "#22c55e", margin: 0 }}>
🟢 {t("commandCenter.status.active")}
</p>
</div>

{/* MemoryAgent */}

<div
style={{
padding: "12px",
minHeight: "60px",
textAlign: "center",
background: "#0f172a",
borderRadius: "10px",
border: "1px solid #1e293b"
}}
>
<h4 
style={{ 
marginBottom: "8px" 
}}
>
{t("dashboard.agentNetwork.memoryAgent")}
</h4>

<p 
style={{ 
color: "#22c55e", 
margin: 0 }}>
🟢 {t("commandCenter.status.active")}
</p>
</div>

{/* LearningAgent */}

<div
style={{
padding: "12px",
minHeight: "60px",
textAlign: "center",
background: "#0f172a",
borderRadius: "10px",
border: "1px solid #1e293b"}}
>
<h4
style={{
marginBottom: "8px",
}}
>
{t("dashboard.agentNetwork.learningAgent")}
</h4>


<p style={{ color: "#22c55e", margin: 0 }}>
🟢 {t("commandCenter.status.active")}
</p>
</div>

</div>

</div>

{/* ===================================================== */}
{/* ===== EXECUTIVE AI SUMMARY ===== */}
{/* ===================================================== */}



<div
style={{
marginTop:"15px",
background:"#111827",
padding:"15px",
borderRadius:"14px",
border:"1px solid #1e293b"
}}
>

<h3
style={{
  textAlign:"center",
  marginBottom:"20px",
  color:"#ffffff"
}}
>
{t("dashboard.executiveSummary.title")}
</h3>

<p
style={{
  textAlign:"center",
  color:"#cbd5e1",
  lineHeight:"1.8",
  maxWidth:"1000px",
  margin:"0 auto"
}}
>

{t(`dashboard.executiveSummary.${riskKey}`)}
</p>

</div>


<div
style={{
marginTop:"20px",
padding:"12px",
textAlign:"center",
color:"#64748b",
fontSize:"13px"
}}
>
{t("dashboard.footerTagline")}
</div>

<SubPageNav current="dashboard" />

{/* ===== MAIN DASHBOARD CONTAINER END ===== */}

</div>

);

}

export default Dashboard;